export enum StaticMenuItems {
  CityLeading = 1,
  FAQ = 2,
  Report = 3,
  InterestsSettings = 4,
}
